import type { KyInstance } from 'ky';

import { ensureError, formatString } from '@enterprise/core';
import type { OperationResult } from '@enterprise/types';

import { Uri } from '#constants/uri';

/**
 * Soft-deletes a permission and removes its role and user grants.
 *
 * @param instance - Ky HTTP instance from the application store.
 * @param uid - Unique identifier of the permission to delete.
 * @returns OperationResult (no payload).
 */
export const deletePermission = async (instance: KyInstance, uid: string) => {
  try {
    return await instance.delete<OperationResult>(formatString(Uri.permissions.byUid, uid)).json();
  } catch (e) {
    const error = ensureError(e);

    throw error;
  }
};
